export default {
  isLoading: false,
  isSendFormCompanyBankAccount: false,
  error: null,
  companyBankAccounts: [],
  companyBankAccount: {
    account_number: '',
    bank_id: 1,
    bank_name: '',
    currency: 'UAH',
    id: 0,
    is_visible: false,
    mfo: '',
    name: '',
    overdraft: 0,
  },
}
